<template>
	<div>
		<div v-if="policies.length !== 0">
			<v-tabs
				v-model="tab"
				bg-color="transparent"
			>
				<v-tab
					:value="0"
					background-color="transparent"
				>
					<div style="font-size: 16px">
						1. <translate>Your objection</translate>
					</div>
				</v-tab>
				<v-tab
					:value="1"
					:disabled="tab < 1"
				>
					<div style="font-size: 16px">
						2. <translate>Your details</translate>
					</div>
				</v-tab>
				<v-tab
					:value="2"
					:disabled="tab < 2"
				>
					<div style="font-size: 16px">
						3. <translate>Check</translate>
					</div>
				</v-tab>
			</v-tabs>

			<v-window v-model:model-value="tab">
				<v-window-item>
					<v-card variant="flat">
						<v-card-text>
							<v-row>
								<v-col>
									<h2>
										<translate>
											File objection
										</translate>
									</h2>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<p>
										<translate>
											We can imagine that you expected a different outcome. Don't agree with the
											rejection of your claim and believe that your claim is covered? You can object to
											the rejection by filling out the form below. We will then take another look at the
											decision and include your objection in the review.
										</translate>
									</p>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h2>
										<translate>
											Period for objections
										</translate>
									</h2>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<p>
										<translate>
											If you want to file an objection to a decision from Tulip Assist you must do so as
											soon as possible but in any case within 14 days from the day you received the
											decision (rejection) via email.
										</translate>
									</p>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h2>
										<translate>
											Processing time
										</translate>
									</h2>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<p>
										<translate>
											We try to process your objection as soon as possible, but will make sure that it
											receives an answer within 15 business days.
										</translate>
									</p>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h2><translate>Objection form</translate></h2>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<h4><strong><translate>What is the claim number?</translate></strong></h4>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<v-radio-group
										v-model="chooseClaim"
										:error-messages="errors.chooseClaim"
									>
										<v-radio
											v-for="policy in policies"
											:key="createPolicyLabel(policy)"
											:value="policy"
											color="primary"
											:label="createPolicyLabel(policy)"
										/>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h4><strong><translate>Give a clear and complete explanation on why you believe the claim is covered below. In the explanation, please discuss the contents of the rejection email you received.</translate></strong></h4>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<v-textarea
										v-model="explanationClaim"
										:error-messages="errors.explanationClaim"
										auto-grow
										color="primary"
										:label="$gettext('Enter your explanation here')"
										rows="6"
										variant="outlined"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h4><strong><translate>Describe the desired solution below.</translate></strong></h4>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<v-textarea
										v-model="desiredSolution"
										:error-messages="errors.desiredSolution"
										auto-grow
										color="primary"
										:label="$gettext('Enter the solution you want here')"
										rows="6"
										variant="outlined"
									/>
								</v-col>
							</v-row>
							<v-row>
								<v-col>
									<h4><strong><translate>Include attachment (optional)</translate></strong></h4>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col>
									<file-input
										v-model="attachment"
										show-size
										color="primary"
										variant="outlined"
										accept="image/*,.pdf"
										:label="$gettext('Upload an image or pdf file')"
									/>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-window-item>

				<v-window-item>
					<my-profile
						:user-business="userBusiness"
						:user-personal="userPersonal"
						:user-address="userAddress"
						:user-email="userEmail"
						:user-telephone-numbers="userTelephoneNumbers"
						:user-bank="userBank"
						:user-newsletter="userNewsletter"
						:new-window="true"
					/>
				</v-window-item>
				<v-window-item>
					<v-card variant="flat">
						<v-card-text>
							<v-row>
								<v-col>
									<h2>
										<translate>Your objection </translate>
									</h2>
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col md6>
									<strong><translate>Claim number</translate>:</strong>
								</v-col>
								<v-col md6>
									{{ getSelectedPolicyNumber }}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col md6>
									<strong><translate>Insured device</translate>:</strong>
								</v-col>
								<v-col md6>
									{{ getSelectedPhone }}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col md6>
									<strong><translate>Explanation objection</translate>:</strong>
								</v-col>
								<v-col md6>
									{{ explanationClaim }}
								</v-col>
							</v-row>

							<v-row no-gutters>
								<v-col md6>
									<strong><translate>Desired solution</translate>:</strong>
								</v-col>
								<v-col md6>
									{{ desiredSolution }}
								</v-col>
							</v-row>
							<v-row no-gutters>
								<v-col md6>
									<strong><translate>Attachment (optional)</translate></strong>
								</v-col>
								<v-col md6>
									<div v-if="attachment !== null">
										{{ getAttachmentName }}
									</div>
								</v-col>
							</v-row>
						</v-card-text>
					</v-card>
				</v-window-item>
			</v-window>
			<v-row>
				<v-col cols="auto">
					<v-btn
						v-if="tab !== 0"
						variant="text"
						color="primary"
						@click="() => { if (tab > 0) --tab; }"
					>
						<translate>Previous</translate>
					</v-btn>
				</v-col>
				<v-spacer />
				<v-col cols="auto">
					<v-btn
						v-if="tab === 2"
						color="primary"
						@click="submitObjectionForm"
					>
						<translate key="Send">
							Send
						</translate> <!-- key doesn't do anything but is necessary for an edge case bug with <translate -->
					</v-btn>
					<v-btn
						v-else
						color="primary"
						@click="nextTab"
					>
						<translate key="Next">
							Next
						</translate>
					</v-btn>
				</v-col>
			</v-row>
		</div>
		<div v-else>
			<translate>You have no rejected claims at the moment</translate>
		</div>
	</div>
</template>

<script>

import axios from 'axios';
import {
	inform,
} from 'laravel-front-library';
import RouteTranslator from '../../mixins/RouteTranslator';

export default {
	name: 'ObjectionForm',
	mixins: [RouteTranslator, ],
	props: {
		policies: {
			type: Array,
			required: false,
			/**
			 * @returns {Array}
			 */
			default: function () {
				return [];
			},
		},

		/* The following props are for the user detail page */
		userBusiness: {
			type: Object,
			required: true,
		},
		userPersonal: {
			type: Object,
			required: true,
		},
		userAddress: {
			type: Object,
			required: false,
			/**
			 * @returns {object}
			 */
			default: function () {
				return {
				};
			},
		},
		userEmail: {
			type: String,
			required: true,
		},
		userTelephoneNumbers: {
			type: Array,
			required: true,
		},
		userBank: {
			type: Array,
			required: true,
		},
		userNewsletter: {
			type: Number,
			required: true,
		},

	},

	data () {
		return {
			tab: 0,
			chooseClaim: null,
			explanationClaim: '',
			desiredSolution: '',
			attachment: null,
			attachmentName: '',
			errors: this.getInitialErrors,
			submitRoute: '/dashboard/objections/submitobjection',
			dashboardRoute: '/dashboard',
		};
	},

	computed: {
		getSelectedPhone: function () {
			return (this.chooseClaim !== null && ('phoneName' in this.chooseClaim)) ? this.chooseClaim.phoneName : '';
		},
		getSelectedPolicyNumber: function () {
			return (this.chooseClaim !== null && ('policyNumber' in this.chooseClaim)) ? this.chooseClaim.policyNumber : '';
		},
		getAttachmentName: function () {
			return this.attachment !== null ? this.attachment[0].name : '';
		},
	},

	created () {
		this.translateRoute('/dashboard/objections/submitobjection').then((translatedPath) => {
			this.submitRoute = translatedPath;
		});
		this.translateRoute('/dashboard').then((translatedPath) => {
			this.dashboardRoute = translatedPath;
		});
	},

	methods: {
		/**
		 * Gets the initial error object
		 *
		 * @returns {object} the initial errors object
		 */
		getInitialErrors () {
			return {
				chooseClaim: null,
				explanationClaim: null,
				desiredSolution: null,
			};
		},


		/**
		 * @param {object} policy
		 * @returns {string}
		 */
		createPolicyLabel (policy) {
			return policy.policyNumber.concat(', ', this.$gettext(policy.claimStatus), ', ', policy.dateTime, ', ', policy.phoneName);
		},

		/**
		 * Submit the objection form data to our backend
		 *
		 * @returns {void}
		 */
		submitObjectionForm () {
			/* eslint-disable*/
			const dataToSend = JSON.stringify({
				policy_number: this.getSelectedPolicyNumber,
				policy_device: this.getSelectedPhone,
				objection_description: this.explanationClaim,
				objection_wanted_solution: this.desiredSolution,
				attachment_name: this.getAttachmentName,
			});
			const formData = new FormData();

			formData.set('formData', dataToSend);
			if (this.attachment !== null) {
				formData.append('attachment', this.attachment[0]);
			}

			axios({
				url: this.submitRoute,
				method: 'POST',
				dataType: 'json',
				data: formData,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				},
			}).then((response) => {
				inform(this.$gettext('Objections submitted'));
				window.location.href = this.dashboardRoute;
				inform(this.$gettext('Objections submitted'));

			})
				.catch((error) => {
					inform(this.$gettext('Submission failure. Please contact bezwaar@tulipassist.nl directly'));
					window.captureException(error);
				});
		},

		/**
		 * Attempts to move to the next tab, sets an error if not able
		 *
		 * @returns {void}
		 */
		nextTab () {
			if (this.tab < 2) {
				if (this.tab === 0) {

					this.errors = this.getInitialErrors();
					if (this.chooseClaim === null) {
						this.errors.chooseClaim = 'Please check one of the available claims';
					}
					if (this.explanationClaim === '') {
						this.errors.explanationClaim = 'Please fill in your explanation';
					}
					if (this.desiredSolution === '') {
						this.errors.desiredSolution = 'Please fill in your desired solution';
					}

					for (const value in this.errors) {
						if (Object.hasOwnProperty.call(this.errors, value)) {
							if (this.errors[value] !== null) {
								return;
							}
						}
					}
				}
				this.tab++;
			}
		},
	},
};
</script>

<style scoped>
    *{text-transform: none !important;}
    ::v-deep .v-input__control {
        width: 100%
    }
    ::v-deep .theme--light.v-tabs-items {
        background-color: transparent;
    }
</style>
